
$(document).ready(function () {


    actOnclickedString($("#id_gateway_0").val())	
	
  $("#id_gateway_0").click(function(){
    actOnclickedString($("#id_gateway_0").val())				
  });
  $("#id_gateway_1").click(function(){
    actOnclickedString($("#id_gateway_1").val())		
  });  
  $("#id_gateway_2").click(function(){
    actOnclickedString($("#id_gateway_2").val())				
  });  
  $("#id_gateway_3").click(function(){	
    actOnclickedString($("#id_gateway_3").val())				
  });
  $("#id_gateway_4").click(function(){
    actOnclickedString($("#id_gateway_4").val())			
  });
  $("#id_gateway_5").click(function(){
    actOnclickedString($("#id_gateway_5").val())			
  }); 
  $("#id_gateway_6").click(function(){
    actOnclickedString($("#id_gateway_6").val())			
  });  
  $("#id_gateway_7").click(function(){
    actOnclickedString($("#id_gateway_7").val())			
  });
  $("#id_gateway_8").click(function(){
    actOnclickedString($("#id_gateway_8").val())			
  });
  $("#id_gateway_9").click(function(){
    actOnclickedString($("#id_gateway_9").val())			
  });  
  $("#id_gateway_10").click(function(){
    actOnclickedString($("#id_gateway_10").val())			
  });  
  $("#id_gateway_11").click(function(){
    actOnclickedString($("#id_gateway_11").val())			
  });  
  $("#id_gateway_12").click(function(){
    actOnclickedString($("#id_gateway_12").val())			
  });   

function actOnclickedString(recString) {
	if(recString  == "dummy")
	{
        console.log("dummy clicked")			
		$("#gatewayNamedummy_pgf").show();	
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();	
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").show();	
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();	
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();	
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
		
	}else if(recString == "bankTransfer")
	{
        console.log("paytm clicked")			
		$("#gatewayNamedummy_pgf").hide();	
		$("#gatewayNamebankTransfer_pgf").show();		
		$("#gatewayNamephoneApp_pgf").hide();		
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();		
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();	
		$("#gatewayNamebankTransfer_total").show();		
		$("#gatewayNamephoneApp_total").hide();		
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "phoneApp")
	{
        console.log("paytm clicked")			
		$("#gatewayNamedummy_pgf").hide();	
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").show();		
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();		
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();	
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").show();		
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
		
	}else if(recString == "paytm")
	{
        console.log("paytm clicked")			
		$("#gatewayNamedummy_pgf").hide();	
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").show();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();		
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();	
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").show();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "braintree")
	{
        console.log("braintree clicked")		
		$("#gatewayNamedummy_pgf").hide();	
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").show();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();		
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();	
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").show();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "razorpay")
	{
        console.log("razorpay clicked")		
		$("#gatewayNamedummy_pgf").hide();	
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").show();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();		
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		
		$("#gatewayNamedummy_total").hide();	
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").show();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "stripe")
	{
        console.log("stripe clicked")		
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").show();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").show();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "payu")
	{
		console.log("payu clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").show();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();
		$("#gatewayNamepaytmNetBanking_pgf").hide();		
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").show();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "paytmupi")
	{
		console.log("paytmupi clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();
		$("#gatewayNamepaytmupi_pgf").show();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();		

		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();
		$("#gatewayNamepaytmupi_total").show();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();	
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();				
	}else if(recString == "phoneUpiApp")
	{
		console.log("checkout phoneUpiApp clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").show();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();		
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").show();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "paytmNetBanking")
	{
		console.log("paytmNetBanking clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").show();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").show();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "paytmWallet")
	{
		console.log("paytmWallet clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").show();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").show();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "paytmPostpaid")
	{
		console.log("paytmPostpaid clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").show();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").show();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "paytmDebitCard")
	{
		console.log("paytmDebitCard clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").show();				
		$("#gatewayNamepaytmCreditCard_pgf").hide();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").show();				
		$("#gatewayNamepaytmCreditCard_total").hide();		
	}else if(recString == "paytmCreditCard")
	{
		console.log("paytmCreditCard clicked");
		$("#gatewayNamedummy_pgf").hide();
		$("#gatewayNamebankTransfer_pgf").hide();			
		$("#gatewayNamephoneApp_pgf").hide();			
		$("#gatewayNamepaytm_pgf").hide();	
		$("#gatewayNamebraintree_pgf").hide();	
		$("#gatewayNamerazorpay_pgf").hide();	
		$("#gatewayNamestripe_pgf").hide();	
		$("#gatewayNamepayu_pgf").hide();	
		$("#gatewayNamepaytmupi_pgf").hide();			
		$("#gatewayNamephoneUpiApp_pgf").hide();	
		$("#gatewayNamepaytmNetBanking_pgf").hide();	
		$("#gatewayNamepaytmWallet_pgf").hide();				
		$("#gatewayNamepaytmPostpaid_pgf").hide();
		$("#gatewayNamepaytmDebitCard_pgf").hide();				
		$("#gatewayNamepaytmCreditCard_pgf").show();
		
		$("#gatewayNamedummy_total").hide();
		$("#gatewayNamebankTransfer_total").hide();			
		$("#gatewayNamephoneApp_total").hide();			
		$("#gatewayNamepaytm_total").hide();	
		$("#gatewayNamebraintree_total").hide();	
		$("#gatewayNamerazorpay_total").hide();	
		$("#gatewayNamestripe_total").hide();	
		$("#gatewayNamepayu_total").hide();	
		$("#gatewayNamepaytmupi_total").hide();			
		$("#gatewayNamephoneUpiApp_total").hide();	
		$("#gatewayNamepaytmNetBanking_total").hide();
		$("#gatewayNamepaytmWallet_total").hide();				
		$("#gatewayNamepaytmPostpaid_total").hide();		
		$("#gatewayNamepaytmDebitCard_total").hide();				
		$("#gatewayNamepaytmCreditCard_total").show();		
	}
	
}	
});


